
import React from 'react'
import { Tabs, DatePicker, Button, Checkbox, Carousel, Menu, Icon } from 'antd';
const TabPane = Tabs.TabPane;
const operations = <Button>Extra Action</Button>;
import { Get, wrapResponse } from './../../../requst'
require('./case.scss')
require('./mobile_case.scss')

export default class Case extends React.Component {
    static async getInitialProps(ctx) {
        const data = await wrapResponse(Get({ url: 'base/cases', data: { type: 1 } }))
        return { data }
    }

    constructor(props, context) {
        super(props, context);
        this.callback = this.callback.bind(this);
        this.state = {
            item: 0
        }

    }

    componentDidMount() {
        !function (e) {
            function t(a) { if (i[a]) return i[a].exports; var n = i[a] = { exports: {}, id: a, loaded: !1 }; return e[a].call(n.exports, n, n.exports, t), n.loaded = !0, n.exports } var i = {};
            return t.m = e, t.c = i, t.p = "", t(0)
        }([function (e, t) {
            "use strict"; Object.defineProperty(t, "__esModule", { value: !0 });
            var i = window;
            t["default"] = i.flex = function (normal, e, t) {
                var a = e || 100, n = t || 1, r = i.document, o = navigator.userAgent, d = o.match(/Android[\S\s]+AppleWebkit\/(\d{3})/i), l = o.match(/U3\/((\d+|\.){5,})/i), c = l && parseInt(l[1].split(".").join(""), 10) >= 80, p = navigator.appVersion.match(/(iphone|ipad|ipod)/gi), s = i.devicePixelRatio || 1;
                p || d && d[1] > 534 || c || (s = 1); var u = normal ? 1 : 1 / s, m = r.querySelector('meta[name="viewport"]'); m || (m = r.createElement("meta"), m.setAttribute("name", "viewport"), r.head.appendChild(m)), m.setAttribute("content", "width=device-width,user-scalable=no,initial-scale=" + u + ",maximum-scale=" + u + ",minimum-scale=" + u), r.documentElement.style.fontSize = normal ? "50px" : a / 2 * s * n + "px"
            }, e.exports = t["default"]
        }]); flex(false, 100, 1);

        this.setState({ offsetWidth: document.body.offsetWidth })
    }
    callback(key) {
        // console.log(key);
        this.Get({ url: 'base/cases', data: { type: key } }).then((res) => {

            this.setState({ data: res.data.data })
        })
    }
    banner() {
        if (this.props.data && this.props.data.length > 2) {
            return this.props.data[`${this.state.item}`].thumb.map((item, index) => {
                if (index > 0) {
                    return (
                        <div key={index}>
                            <img src={item} alt="" />
                        </div>
                    )
                }
            })
        }


    }
    handleClick(parames) {
        // if (parames==0) {
        //     this.
        // }
    }

    render() {
        const TabPane = Tabs.TabPane;
        const operations = <Button>Extra Action</Button>;
        let caseNum = 1;
        if (this.state.offsetWidth >= 1200) {
            return (
                <div className="CaseContainer">
                    <div className="CaseTitle">
                        <p>开发案例</p>
                        <p>Development case</p>
                        <img src={require('../../../assets/common/images/biaotizhuangshi.png')} alt="" />
                    </div>
                    <Tabs defaultActiveKey="1" onChange={this.callback}>

                        <TabPane tab="APP开发" key="1">
                            {this.props.data && this.props.data.length > 2 ?
                                <div className="CaseContent" style={{ display: 'flex' }}>
                                    <div className="Lift" style={{ flex: '2', display: 'flex' }}>
                                        <div className="ListOne" style={{ marginLeft: '-20px', cursor: 'pointer' }} onClick={() => this.setState({ item: 1 })}>
                                            <div className="ImgShow">
                                                <img src={this.props.data ? this.props.data[1].thumb[1] : null} alt="" onClick={this.handleClick} />
                                            </div>
                                        </div>
                                        {this.props.data ?
                                            <div className="ListTwo" style={{ cursor: 'pointer' }} onClick={() => this.setState({ item: 2 })}>
                                                <div className="ImgShow">
                                                    <img src={this.props.data[2].thumb[1]} alt="" onClick={this.handleClick} />
                                                </div>
                                            </div>
                                            : null}
                                    </div>
                                    <div className="Right" style={{ flex: '5', display: 'flex' }}>
                                        <div className="Phone">
                                            <Carousel autoplay >
                                                {/*autoplay*/}
                                                {this.props.data && this.props.data.length > 2 ? this.banner() : null}

                                            </Carousel>
                                        </div>
                                        <div style={{ flex: '1' }}></div>
                                        <div style={{ flex: '3', display: 'flex', alignItems: 'center' }}>
                                            <div className="TextBox" style={{ maxWidth: '420px' }}>
                                                <p className="TextHead">{this.props.data ? this.props.data[`${this.state.item}`].title : null}</p>
                                                <p className="TextCont">{this.props.data ? this.props.data[`${this.state.item}`].desc : null}</p>
                                                <a href={`/casedetails/${this.props.data[this.state.item].id}`} className="Btn">详情</a>
                                            </div>
                                        </div>

                                    </div>
                                </div> : null
                            }


                        </TabPane>
                        <TabPane tab="微信开发" key="2">
                            {this.props.data && this.props.data.length > 1 ?
                                <div className="CaseContent" style={{ display: 'flex' }}>
                                    <div className="Lift" style={{ flex: '2', display: 'flex' }}>
                                        <div className="ListOne" style={{ marginLeft: '-20px', cursor: 'pointer' }} onClick={() => this.setState({ item: 0 })}>
                                            <div className="ImgShow">
                                                <img src={this.props.data ? this.props.data[0].thumb[1] : null} alt="" onClick={this.handleClick} />
                                            </div>
                                        </div>
                                        <div className="ListTwo" style={{ cursor: 'pointer' }} onClick={() => this.setState({ item: 1 })}>
                                            <div className="ImgShow">
                                                <img src={this.props.data ? this.props.data[1].thumb[1] : null} alt="" onClick={this.handleClick} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="Right" style={{ flex: '5', display: 'flex' }}>
                                        <div className="Phone">
                                            <Carousel autoplay >
                                                {/*autoplay*/}
                                                {this.props.data ? this.banner() : null}
                                            </Carousel>
                                        </div>
                                        <div style={{ flex: '1' }}></div>
                                        <div style={{ flex: '3', display: 'flex', alignItems: 'center' }}>
                                            <div className="TextBox" style={{ maxWidth: '420px' }}>
                                                <p className="TextHead">{this.props.data ? this.props.data[`${this.state.item}`].title : null}</p>
                                                <p className="TextCont">{this.props.data ? this.props.data[`${this.state.item}`].desc : null}</p>
                                                <a href={`/casedetails/${this.props.data[this.state.item].id}`} className="Btn">
                                                    详情>
                                        </a>
                                            </div>
                                        </div>

                                    </div>
                                </div> : null
                            }
                        </TabPane>
                        <TabPane tab="电商SaaS" key="3">
                            {this.props.data && this.props.data.length > 1 ?
                                <div className="CaseContent CaseWeb" style={{ display: 'flex' }}>
                                    <div className="Lift" style={{ flex: '1', display: 'flex' }}>
                                        <div className="ListOne" style={{ marginLeft: '-20px', cursor: 'pointer' }} onClick={() => this.setState({ item: 0 })}>
                                            <img src={this.props.data ? this.props.data[0].thumb[1] : null} alt="" onClick={this.handleClick} />
                                        </div>
                                    </div>
                                    <div className="Right" style={{ flex: '5', display: 'flex' }}>
                                        <div className="Phone">
                                            <Carousel autoplay >
                                                {/*autoplay*/}
                                                {this.props.data ? this.banner() : null}
                                            </Carousel>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div className="TextBox" style={{ maxWidth: '320px' }}>
                                                <p className="TextHead">{this.props.data ? this.props.data[`${this.state.item}`].title : null}</p>
                                                <p className="TextCont">{this.props.data ? this.props.data[`${this.state.item}`].desc : null}</p>
                                                <a href={`/casedetails/${this.props.data[this.state.item].id}`} className="Btn" >
                                                    详情>
                                            </a>
                                            </div>
                                        </div>

                                    </div>
                                </div> : null
                            }
                        </TabPane>
                        <TabPane tab="网站开发" key="4">
                            {this.props.data && this.props.data.length > 2 ?
                                <div className="CaseContent CaseWeb" style={{ display: 'flex' }}>
                                    <div className="Lift" style={{ flex: '1', display: 'flex' }}>
                                        <div className="ListOne" style={{ marginLeft: '-20px', cursor: 'pointer' }} onClick={() => this.setState({ item: 0 })}>
                                            <img src={this.props.data ? this.props.data[0].thumb[1] : null} alt="" onClick={this.handleClick} />
                                        </div>
                                    </div>
                                    <div className="Right" style={{ flex: '5', display: 'flex' }}>
                                        <div className="Phone">
                                            <Carousel autoplay >
                                                {/*autoplay*/}
                                                {this.props.data ? this.banner() : null}

                                            </Carousel>
                                        </div>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div className="TextBox" style={{ maxWidth: '320px' }}>
                                                <p className="TextHead">{this.props.data ? this.props.data[`${this.state.item}`].title : null}</p>
                                                <p className="TextCont">{this.props.data ? this.props.data[`${this.state.item}`].desc : null}</p>
                                                <a href={`/casedetails/${this.props.data[this.state.item].id}`} className="Btn">
                                                    详情>
                                            </a>
                                            </div>
                                        </div>

                                    </div>
                                </div> : null
                            }
                        </TabPane>
                    </Tabs>
                    <div className="CaseFooter">
                        <a href="/caseshow">更多案例</a>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="Mobile_CaseContainer">
                    <p className="Mobile_Title">开发案例</p>
                    <p className="Mobile_SubTitle">DEVELOPMENT CASE</p>
                    <img src={require('../../../assets/common/images/biaotizhuangshi.png')} alt="" />
                    <table className="Mobile_Table">
                        <tbody>
                            <tr>
                                <td>
                                    <a href="###">APP开发</a>
                                    <p></p>
                                </td>
                                <td>
                                    <a href="###">微信开发</a>
                                    <p></p>
                                </td>
                                <td><a href="###">电商SaaS</a></td>
                                <td><a href="###">网站开发</a></td>
                            </tr>
                        </tbody>
                    </table>
                    <ul className="Mobile_CaseImg">
                        <li className="fl">
                            <img src={require('../../../assets/common/images/shiyan.jpg')} alt="" />
                        </li>
                        <li className="fr">
                            <img src={require('../../../assets/common/images/shiyan.jpg')} alt="" />
                        </li>
                    </ul>
                    <button></button>
                </div>
            )
        }

    }
}